import { Temporal } from "@js-temporal/polyfill";
import { Game } from "./core/Game";
import { GameClock, MutableWallClock, SystemWallClock } from "./time/GameClock";
import { GameShell, installDiagnostics } from "./ui/GameShell";
import "./styles.css";

async function boot(): Promise<void> {
  const app = document.querySelector<HTMLDivElement>("#app");
  if (!app) throw new Error("Application root is missing");
  const canvas = document.createElement("canvas");
  canvas.className = "game-canvas";
  canvas.setAttribute("aria-label", "Interactive 3D New York City");
  app.append(canvas);
  let mutableClock: MutableWallClock | undefined;
  if (!import.meta.env.PROD) {
    const value = new URLSearchParams(location.search).get("clock");
    if (value) {
      try {
        mutableClock = new MutableWallClock(Temporal.ZonedDateTime.from(value).toInstant());
      } catch {
        /* invalid overrides use system time */
      }
    }
  }
  const clock = new GameClock(mutableClock ?? new SystemWallClock());
  try {
    const game = await Game.create(canvas, clock);
    const shell = new GameShell(game);
    installDiagnostics(game, mutableClock);
    window.addEventListener(
      "beforeunload",
      () => {
        shell.dispose();
        game.dispose();
      },
      { once: true },
    );
  } catch (error) {
    canvas.remove();
    const message = error instanceof Error ? error.message : "The city could not be initialized.";
    const screen = document.createElement("section");
    screen.className = "screen error-screen";
    screen.innerHTML = `<div class="title-panel"><h1 class="wordmark">VOX<span>CITY</span></h1><p class="title-subtitle">City loading failed.</p><p>${message}</p><div class="title-actions"><button class="primary" onclick="location.reload()">Retry</button></div></div>`;
    app.append(screen);
  }
}

void boot();
